import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import keycloak from './keyCloak';
import { AuthProvider } from './contexts/AuthContext'; // import context

keycloak
  .init({ onLoad: 'login-required' })
  .then((authenticated) => {
    if (authenticated) {
      const token = keycloak.token;
      const roles = keycloak?.tokenParsed?.resource_access?.['Twilio-Analytics']?.roles || [];

      // ⏰ Set up token refresh every 60 seconds
      setInterval(() => {
        keycloak.updateToken(70).then((refreshed) => {
          if (refreshed) {
            console.log('🔄 Token successfully refreshed');
          } else {
            console.log('⏳ Token still valid');
          }
        }).catch(() => {
          console.warn('❌ Failed to refresh token, forcing logout');
          keycloak.logout();
        });
      }, 240000); // Check every 4 minutes

      const root = ReactDOM.createRoot(document.getElementById('root'));
      root.render(
        <React.StrictMode>
          <AuthProvider>
            <App token={token} roles={roles} userId={keycloak.tokenParsed?.sub} />
          </AuthProvider>
        </React.StrictMode>
      );
    } else {
      window.location.reload();
    }
  })
  .catch((err) => {
    console.error('Keycloak init failed', err);
  });

reportWebVitals();